<template>
  <v-card>
    <v-expansion-panel
      class="full-height"
      :class="!isSmAndDown ? 'hide-expansion' : ''"
      v-model="panel"
      :readonly="!isMobile"
      expand
      :disabled="!isSmAndDown && currentStep === 5 ? true : false"
    >
      <v-expansion-panel-content class="grey lighten-3">
        <div slot="header">
          <div class="summary-header">
            <h3 class="checkout-h3">Seu Pedido</h3>
            <h3
              v-if="
                $route.name !== 'commissioner' &&
                  currentStep !== 5 &&
                  isSmAndDown
              "
              class="checkout-h3"
              style="padding-right: 8px;"
            >
              {{ productsTotal | currency }}
            </h3>
            <h3
              v-if="
                $route.name === 'commissioner' &&
                  currentStep !== 5 &&
                  isSmAndDown
              "
              class="checkout-h3"
              style="padding-right: 8px;"
            >
              {{ (totalModeOrder * 100) | currency }}
            </h3>
            <!-- <h3 v-else-if="currentStep === 5" class="checkout-h3 primary--text" :style="isSmAndDown ? 'padding-right: 8px;' : ''">#{{eventID}} - {{ orderID }}</h3> -->
          </div>
        </div>
        <v-card class="grey lighten-3 summary-content">
          <v-divider></v-divider>
          <h5 class="checkout-h5 summary-content__text grey--text">
            INGRESSOS
          </h5>
          <div
            v-if="
              cartProducts &&
                cartProducts.length === 0 &&
                $route.name !== 'commissioner'
            "
          >
            <h3>Nenhum ingresso selecionado ainda.</h3>
          </div>
          <div
            v-if="$route.name !== 'commissioner'"
            v-for="(product, i) in cartProducts"
            :key="i"
          >
            <h4
              v-for="{
                codigo_produto,
                codigo_tipo,
                nome,
                nome_tipo,
                quantidade,
                valor,
                valor_conveniencia,
                seat_id,
              } in product"
              :key="`${codigo_produto}-${codigo_tipo}`"
              class="summary-content__text checkout-h4"
            >
              {{ quantidade }}x {{ nome }} -{{ nome_tipo }}
              {{ verifySeats(seat_id) }}
              <span v-if="store && store.id === 4" style="float: right" class>
                {{ (quantidade * valor * 100) | currency }}
              </span>
              <span v-else style="float: right" class>
                {{
                  (quantidade * (valor + valor_conveniencia) * 100) | currency
                }}
              </span>
            </h4>
          </div>
          <div
            v-if="productsOrder && $route.name === 'commissioner'"
            v-for="(product, index) in productsOrder"
            :key="index"
          >
            <h4 class="summary-content__text checkout-h4">
              {{ product.quantidade }}x {{ product.nome }} -{{
                product.nome_tipo
              }}
              <!-- {{ verifySeats(seat_id) }} -->
              <span style="float: right" class>
                {{
                  (product.quantidade *
                    (Number(product.valor) +
                      Number(product.valor_conveniencia)) *
                    100)
                    | currency
                }}
              </span>
            </h4>
          </div>

          <div
            v-if="
              ((cartProducts && cartProducts.length > 0) ||
                currentStep !== 5) &&
                store &&
                store.id === 4
            "
            class="summary-content__total my-0"
          >
            <h4 class="checkout-h4 summary-content__text my-2">
              <strong class>Total Ingressos</strong>
            </h4>
            <h4 class="checkout-h4 summary-content__text my-2">
              <strong class>{{ productsTotalWithoutTax | currency }}</strong>
            </h4>
          </div>

          <div
            v-if="
              ((cartProducts && cartProducts.length > 0) ||
                currentStep !== 5) &&
                store &&
                store.id === 4
            "
            class="summary-content__total"
          >
            <h4 class="checkout-h4 summary-content__text my-2 mb-3">
              <strong class>Taxa de Serviço</strong>
            </h4>
            <h4 class="checkout-h4 summary-content__text my-2 mb-3">
              <strong class>{{ taxTotal | currency }}</strong>
            </h4>
          </div>

          <template
            v-if="
              isCardPaymentOption &&
                ($route.name !== 'commissioner' || currentStep !== 5)
            "
          >
            <v-divider></v-divider>
            <h5 class="checkout-h5 summary-content__text grey--text">
              Pagamento
            </h5>
            <v-divider></v-divider>

            <div class="list-item">
              <div>Parcelas</div>
              <div class="bold">
                {{ instalmentAmount }}x {{ interestAmount | currency }}
              </div>
            </div>

            <div v-if="paymentData && paymentData.transaction_charge_credit">
              <v-divider></v-divider>
              <div class="list-item">
                <div style="display: flex; align-items: center;">
                  Taxa de Processamento

                  <v-tooltip bottom color="accent">
                    <v-icon
                      slot="activator"
                      class="alert-card__icon ml-1 mt-1"
                      color="accent"
                      style="font-size: 20px;"
                    >
                      info_outline
                    </v-icon>
                    <span class="white--text"
                      >A taxa de processamento visa cobrir o custo financeiro
                      relacionado com a forma de pagamento escolhida</span
                    >
                  </v-tooltip>
                </div>
                <div class="bold">
                  {{ (paymentData.transaction_charge_credit * 100) | currency }}
                </div>
              </div>
            </div>

            <v-divider></v-divider>
          </template>

          <div class="summary-content__total">
            <h4
              v-if="
                ($route.name !== 'commissioner' &&
                  cartProducts &&
                  cartProducts.length > 0) ||
                  currentStep !== 5
              "
              class="checkout-h4 summary-content__text"
              :class="store && store.id === 4 ? 'my-3' : ''"
            >
              <strong class>Total</strong>
            </h4>
            <h4
              class="checkout-h4 summary-content__text"
              :class="store && store.id === 4 ? 'my-3' : ''"
            >
              <strong
                v-if="
                  $route.name !== 'commissioner' &&
                    cartProducts &&
                    cartProducts.length > 0
                "
                class
                >{{ productsTotal | currency }}</strong
              >
              <strong
                v-if="$route.name === 'commissioner' && currentStep !== 5"
                class
                >{{ (totalModeOrder * 100) | currency }}</strong
              >
            </h4>
          </div>

          <div
            v-if="
              orderPdvData &&
                orderPdvData.valor_pago < Number(orderPdvData.valor_total) &&
                currentStep !== 5
            "
            class="summary-content__total"
          >
            <h4 class="checkout-h4 summary-content__text">
              <strong class>Valor Pago</strong>
            </h4>
            <h4 class="checkout-h4 summary-content__text">
              <strong class>{{
                (orderPdvData.valor_pago * 100) | currency
              }}</strong>
            </h4>
          </div>

          <div
            v-if="currentStep === 5 && itsPartialPayment"
            class="summary-content__total"
          >
            <h4 class="checkout-h4 summary-content__text">
              <strong class>Valor Pago</strong>
            </h4>
            <h4 class="checkout-h4 summary-content__text">
              <strong class>{{ (partialValue * 100) | currency }}</strong>
            </h4>
          </div>

          <div
            v-if="
              orderPdvData &&
                orderPdvData.valor_pago < Number(orderPdvData.valor_total) &&
                currentStep !== 5
            "
            class="summary-content__total"
          >
            <h4 class="checkout-h4 summary-content__text">
              <strong class>Saldo a Pagar</strong>
            </h4>
            <h4 class="checkout-h4 summary-content__text">
              <strong class>{{
                (orderPdvData.valor_pendente * 100) | currency
              }}</strong>
            </h4>
          </div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTableInfo } from '../../mixins/getTableInfo'
export default {
  mixins: [getTableInfo],
  mounted() {
    this.panel = [!this.isMobile];
  },
  data() {
    return {
      panel: [true],
    };
  },
  watch: {
    isMobile(value) {
      this.panel = [!value];
    },
  },
  methods: {
    verifySeats(value) {
      if (!value) return '';
      var sumSeats = '';
      value.forEach(el => {
        if (sumSeats) sumSeats = sumSeats + `, ${this.getIdentification(el)}`;
        else sumSeats = sumSeats + this.getIdentification(el);
      });

      return sumSeats ? `(${sumSeats})` : '';
    },

    getIdentification(el) {
      let formatted = el.replace('Mesa', '');

      const tableOccurences = el.toLowerCase().split("mesa").length - 1;
      const isTableFromRow = tableOccurences === 2
      if (isTableFromRow) {
        if (el.toLowerCase().includes(';')) return this.MIXIN_AUX_getChairInfoFromTable(el)
        else return this.MIXIN_AUX_getTableTooltipInfo(el)
      }

      let getRow = el
        .toString()
        .split(';')
        .shift();
      let getNumber = el
        .toString()
        .split(';')
        .pop();
      if (el.includes('Mesa')) {
        if (el.includes(';'))
          return (
            'Mesa ' +
            formatted.split(';')[0] +
            ' Cadeira ' +
            formatted.split(';').pop()
          );
        else return 'Mesa ' + formatted;
      } else if (el.includes('MESA')) {
        return 'Mesa ' + formatted.split('-')[1];
      }

      return getRow + `-${getNumber}`;
    },
  },
  computed: {
    ...mapGetters([
      'cartProducts',
      'currentStep',
      'instalmentAmount',
      'interestAmount',
      'eventID',
      'orderPdvData',
      'productsOrder',
      'partialValue',
      'store',
      'paymentData',
    ]),
    totalModeOrder() {
      if (this.productsOrder) {
        let total = 0;
        this.productsOrder.forEach(p => {
          total +=
            p.quantidade * (Number(p.valor) + Number(p.valor_conveniencia));
        });
        return total;
      } else return 0;
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'tablet';
    },
    isCardPaymentOption() {
      return (
        this.$store.getters.paymentOption === 'CC' && this.currentStep >= 4
      );
    },
    itsPartialPayment() {
      if (
        this.$route.name !== 'commissioner' &&
        this.paymentData &&
        this.paymentData.split_payment &&
        this.productsTotal &&
        this.partialValue < this.productsTotal
      )
        return Number(this.productsTotal);
      if (
        this.$route.name === 'commissioner' &&
        this.orderPdvData &&
        this.orderPdvData.valor_pendente &&
        this.partialValue < Number(this.orderPdvData.valor_pendente)
      )
        return Number(this.orderPdvData.valor_pendente);
      return 0;
    },
    productsTotal() {
      if (this.isCardPaymentOption) {
        return this.$store.getters.totalAmount;
      }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    productsTotalWithoutTax() {
      // if (this.isCardPaymentOption) {
      //   return this.$store.getters.totalAmount;
      // }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += v.valor * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    taxTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += v.valor_conveniencia * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    orderID() {
      return this.$store.getters.body.codigo_pedido;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/summary/summary.styl';
</style>

<style scoped>
.list-item {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 0;
}
.bold {
  font-weight: bold;
}
.total {
  font-weight: bold;
  font-size: 16px;
}
</style>

<style>
.hide-expansion .v-expansion-panel__header__icon {
  opacity: 0 !important;
}
</style>
